<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="公告类型：" prop="noticeType">
                <el-select
                  size="small"
                  clearable
                  v-model="queryParams.noticeType"
                >
                  <template v-for="(value, key) in dictData['notice_type']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公告标题：" prop="noticeTitle">
                <el-input
                  size="small"
                  v-model="queryParams.noticeTitle"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发布时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="user.userType == '00'" :gutter="24">
            <el-col :span="8">
              <el-form-item label="公告状态：" prop="noticeStatus">
                <el-select
                  size="small"
                  clearable
                  v-model="queryParams.noticeStatus"
                >
                  <template
                    v-for="(value, key) in dictData['sys_notice_status']"
                  >
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作人员：" prop="updateBy">
                <el-input
                  size="small"
                  v-model="queryParams.updateBy"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
          <el-row v-else :gutter="24">
            <el-col :span="24" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <span style="float: left">
          <el-button
            v-if="user.userType == '00'"
            type="primary"
            size="small"
            @click="handleShowEditNotice({})"
            >新增</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table :data="tableData">
        <el-table-column label="公告标题" prop="noticeTitle">
          <template slot-scope="scope">
            <el-badge v-if="scope.row.isTop == '1'" value="置顶" class="item">
              <el-button type="text" @click="handleShowDetail(scope.row)"
                >{{ scope.row.noticeTitle }}
              </el-button>
            </el-badge>
            <el-button v-else type="text" @click="handleShowDetail(scope.row)"
              >{{ scope.row.noticeTitle }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="公告类型" prop="noticeType">
          <template slot-scope="scope">
            <span>{{ dictMap["notice_type"][scope.row.noticeType] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="user.userType == '00'"
          label="公告状态"
          prop="noticeStatus"
        >
          <template slot-scope="scope">
            <span>{{
              dictMap["sys_notice_status"][scope.row.noticeStatus]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="user.userType == '00'"
          label="操作人员"
          prop="updateBy"
        ></el-table-column>
        <el-table-column label="发布时间" prop="createTime"></el-table-column>
        <el-table-column
          v-if="user.userType == '00'"
          label="操作"
          prop="oper"
          fixed="right"
          width="160"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowEditNotice(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="handleDeleteNotice(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="1280px"
    >
      <el-form
        :model="editDialog.noticeForm"
        :rules="editDialog.rules"
        ref="noticeForm"
        class="notice-form"
        label-width="140px"
      >
        <el-form-item label="公告类型" prop="noticeType">
          <el-select
            clearable
            v-model="editDialog.noticeForm.noticeType"
            placeholder="请选择公告类型"
          >
            <template v-for="(value, key) in dictData['notice_type']">
              <el-option
                :key="key"
                :label="value.label"
                :value="value.value"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="公告标题" prop="noticeTitle">
          <el-input v-model="editDialog.noticeForm.noticeTitle"></el-input>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <CKEditor4
            v-model="editDialog.noticeForm.content"
            @getCkEditorInstance="getEditor"
            :config="editorConfig"
            @open="openUploadDialog"
          ></CKEditor4>
        </el-form-item>
        <el-form-item label="公告附件：">
          <el-upload
            ref="upload"
            drag
            action="#"
            :file-list="fileList"
            :auto-upload="false"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :multiple="true"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">大小限制20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="公告状态" prop="noticeStatus">
          <el-radio-group v-model="editDialog.noticeForm.noticeStatus">
            <template v-for="(value, key) in dictData['sys_notice_status']">
              <el-radio :label="value.value" :key="value.value">
                {{ value.label }}</el-radio
              >
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否置顶" prop="isTop">
          <el-radio-group v-model="editDialog.noticeForm.isTop">
            <!-- <template v-for="(value, key) in dictData['yes_or_no']">
              <el-radio :label="key" :key="key"> {{ value }}</el-radio>
            </template> -->
            <el-radio label="0"> 否</el-radio>
            <el-radio label="1"> 是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveNotice"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getNoticeList,
  exportNoticeList,
  addNotice,
  updateNotice,
  deleteNotice,
} from "@/api/sysSupport/notice"
import CKEditor4 from "@/components/common/CKEditor"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import { uploadFile } from "@/api/upload/upload"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
    CKEditor4,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        noticeStatus: undefined,
        updateBy: undefined,
        noticeTitle: undefined,
        noticeType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      total: 0,
      tableData: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        noticeForm: {},
        rules: {
          noticeType: [
            { required: true, message: "请选择公告类型", trigger: "blur" },
          ],
          noticeTitle: [
            { required: true, message: "请输入公告标题", trigger: "blur" },
          ],
          noticeStatus: [
            { required: true, message: "请选择公告状态", trigger: "blur" },
          ],
          isTop: [
            { required: true, message: "请选择是否置顶", trigger: "blur" },
          ],
        },
      },
      editor: null,
      editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
      fileList: [],
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    ...mapGetters(["user"]),
  },
  created() {
    this.loadData()
  },
  methods: {
    /** 查询公告列表 */
    loadData() {
      if (this.user.userType !== "00") {
        this.queryParams.noticeStatus = "1"
      }
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = ""
        this.queryParams.endTime = ""
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      getNoticeList(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },

    /**显示编辑页面 */
    handleShowEditNotice(row) {
      if (row.noticeId) {
        this.editDialog.noticeForm = Object.assign({}, row)
        this.editDialog.title = "编辑公告"
      } else {
        this.editDialog.noticeForm = { isTop: "0", noticeStatus: "1" }
        this.editDialog.title = "新增公告"
      }
      this.editDialog.dialogVisible = true
      // this.editor.setData(row.content)
    },

    /**保存公告信息 */
    handleSaveNotice() {
      this.startLoading()
      this.$refs["noticeForm"].validate(async (valid) => {
        if (valid) {
          if (this.fileList.length > 0) {
            const file = this.fileList[0]
            if (file.raw) {
              if (true) {
                const isLt2M = file.size / 1024 / 1024 < 20
                if (!isLt2M) {
                  _self.msgError(`${file.name}超过20M，上传失败！`)
                  this.endLoading()
                  return
                }
                const { uploadFlag, fileUrl } = await uploadFile(file)
                if (!uploadFlag) {
                  _self.msgError("上传失败！")
                  this.endLoading()
                  return
                }
                this.editDialog.noticeForm.attachUrl = fileUrl
              }
            }
          }

          this.editDialog.noticeForm.content = this.editor.getData()
          if (this.editDialog.noticeForm.noticeId) {
            updateNotice(this.editDialog.noticeForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("修改失败")
              }
            })
          } else {
            addNotice(this.editDialog.noticeForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("新增失败")
              }
            })
          }
          this.endLoading()
        } else {
          console.log("error submit!!")
          this.endLoading()
          return false
        }
      })
    },
    /**删除公告 */
    handleDeleteNotice(row) {
      this.$confirm("确认删除公告？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteNotice(row).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!")
      }
      return isLt2M
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    /**详情 */
    handleShowDetail(row) {
      if (this.user.userType == "00") {
        this.$router.push({
          path: "/service/manage/notice_detail",
          query: { noticeId: row.noticeId },
        })
      } else {
        this.$router.push({
          path: "/system/advisory/announcement_detail",
          query: { noticeId: row.noticeId },
        })
      }
    },

    download(row) {
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      exportNoticeList(params).then((response) => {
        if (response.code == "200") {
          this.$message.success("导出成功！")
        } else {
          this.$message.error("导出失败！")
        }
      })
    },

    getEditor(editor) {
      this.editor =
        this.localUploadData.editor =
        this.onlineUploadData.editor =
          editor
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
::v-deep .el-badge__content {
  position: relative;
  top: 6px;
  right: 30px;
}
.notice-form {
  padding: 10px 30px 0 0;
  height: 60vh;
  overflow: auto;
}
</style>
